import * as Yup from "yup";

export const apiKeyValidationSchema = Yup.object({
  clientId: Yup.string().required("Client ID is required"),
  clientSecret: Yup.string().required("Client Secret is required"),
});
